/**
 * QuantityStepper — how many passes the order buys.
 *
 * Always present on a pass checkout. `max` is the SERVER's number — the order
 * ceiling, or an applied promo's `maxItemsPerRedemption` when that is lower —
 * and the component only reflects it; it never decides it.
 *
 * Native `<button>`s and an `<output>`: no React state of its own (Native Web
 * First). The value lives in the purchase context, written from these handlers.
 *
 * @module pages/subscription/steps/QuantityStepper
 */

import { QuantityStepper as QuantityStepperControl } from '@butter/ui/components/inputs';

export function QuantityStepper({
  quantity,
  max,
  onChange,
  disabled = false,
}: {
  quantity: number;
  /** Inclusive upper bound. */
  max: number;
  onChange: (next: number) => void;
  disabled?: boolean;
}) {
  const stepClass = 'size-9 text-interactive:bg-butter-gray-200';

  return (
    <div
      className="flex items-center justify-between rounded-3xl border border-gray-200 px-6 py-4"
      data-testid="subscription-quantity"
    >
      <p className="text-base font-medium text-fg-primary">
        Quantity <span className="text-xs font-normal text-fg-tertiary">(max {max})</span>
      </p>
      <QuantityStepperControl
        value={quantity}
        max={max}
        disabled={disabled}
        onChange={onChange}
        className="gap-1 rounded-full bg-butter-gray-100 p-1"
        buttonClassName={stepClass}
        valueClassName="w-8 text-sm font-medium"
        decreaseTestId="subscription-quantity-decrease"
        increaseTestId="subscription-quantity-increase"
        valueTestId="subscription-quantity-value"
      />
    </div>
  );
}
